import { createContext } from "react";

/** Whether the profiling chart has both a baseline and a comparison selected. */
const ProfilingComparisonContext = createContext<boolean>(false);
ProfilingComparisonContext.displayName = "ProfilingComparisonContext";

export default ProfilingComparisonContext;
